import { mainRoutes } from './main';
import { Navigate, useRoutes } from 'react-router-dom';

import MainLayout from 'src/layouts/main';
import { authDemoRoutes } from './auth-demo';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { ClientHome } from 'src/sections/client-home/view';

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <ClientHome />
        </MainLayout>
      ),
    },
    ...authRoutes,
    ...authDemoRoutes,
    ...dashboardRoutes,
    ...mainRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
